import { Typography, Box, List, ListItemButton, ListItemText, ListItemAvatar } from '@mui/material';
import ResourcesLinks from './ResourcesLinks';
import LinkIcon from '@mui/icons-material/Link';

const References = (props) => {
  return (
    <Box sx={{ mt: '4rem' }}>
      <Typography variant='h4' component='h2' sx={{ fontWeight: 'bold', mb: '1rem' }}>
        See What Others Say
      </Typography>
      <div>
        {ResourcesLinks.map((section) => {
          return (
            <>
              {section.articles.map((item) => {
                return (
                  <List>
                    <ListItemButton component='a' href={item.url} target='_blank' sx={{ mb: '-1rem' }}>
                      <ListItemAvatar>
                        <LinkIcon />
                      </ListItemAvatar>
                      <ListItemText primary={item.title} />
                    </ListItemButton>
                  </List>
                );
              })}
            </>
          );
        })}
      </div>
    </Box>
  );
};

export default References;
